import { useContext, useEffect, useState, useRef } from 'react';
import ContextStates from '../context/ContextStates';
import axios from 'axios';
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'
import DetallePedido from './detallePedido';
import { Url } from './Url';
import Select from 'react-select';
import SearchAutoComplete from './searchAutoComplete';
import SearchAutoCompCli from './searchAutoCompCli';

const FinalizarVenta = () => {
    const [total, setTotal] = useState(0)
    const [cliente, setCliente] = useState(0)
    const [fecha, setFecha] = useState('')
    const [hora, setHora] = useState('')
    const [nombre, setNombre] = useState('')
    const [razonSocial, setRazonSocial] = useState('')
    const [cuit, setCuit] = useState('')
    const [fechaInicio, setFechaInicio] = useState('')
    const [medios, setMedios] = useState([])
    const [medioPago, setMedioPago] = useState('1')
    const [efectivo, setEfectivo] = useState('')
    const [procesando, setProcesando] = useState(false)
    const [datosFactura, setDatosFactura] = useState('')
    const [finVenta, setFinVenta] = useState(false)
    const [envases, setEnvases] = useState([])
    const [envase, setEnvase] = useState(0)
    const [cantidadEnv, setCantidadEnv] = useState("")
    const [listEnvases, setListEnvases] = useState([])
    const [descuentos, setDescuentos] = useState([])
    const [horaCustom, setHoraCustom] = useState('00:00')
    const [custom, setCustom] = useState(false)
    const [idComprobante, setIdComprobante] = useState(0)
    const { venta, precio, setVenta, setFormView, setViewOpen, modify, setModify, idCliente, setIdCliente, searchCliente, setSearchCliente, idUsuario, clientes, auxVenta, setAuxVenta,
        auxTotal, setAuxTotal, setClientes, setFormPrev, puntoVenta, porcentajeTransf } = useContext(ContextStates);
    const componentRef = useRef();

    useEffect(() => {
        const calcTotal = () => {
            let aux = 0;
            let rData = [...descuentos]
            venta.forEach(element => {
                if (!precio) {
                    if (element.tipopromo === '1' || element.tipopromo === '2') {
                        aux = aux + parseFloat(element.preciopromocion * element.cantidad);
                        let montoDesc = (parseFloat(element.precio) * element.cantidad) - parseFloat(element.preciopromocion * element.cantidad);
                        let descuento = {
                            id: element.id,
                            descripcion: element.descripcion,
                            monto: montoDesc
                        }
                        rData.push(descuento)
                    }
                    else {
                        if (element.tipopromo === '3') {
                            let precio = 0;
                            if (element.cantidad >= element.cantidadminima) {
                                let cantPromos = parseFloat(element.cantidad) / parseFloat(element.cantidadminima);
                                let cantPagos = element.cantidad - (parseFloat(element.cantidaddescuento) * cantPromos);
                                precio = cantPagos * parseFloat(element.precio);
                                let montoDesc = (parseFloat(element.precio)) * element.cantidad - precio;
                                let descuento = {
                                    id: element.id,
                                    descripcion: element.descripcion,
                                    monto: montoDesc
                                }
                                rData.push(descuento)
                            } else {
                                precio = parseFloat(element.cantidad) * (parseFloat(element.precio));
                            }
                            aux = aux + precio;
                        } else {
                            aux = aux + (parseFloat(element.precio)) * element.cantidad;
                        }
                    }
                }
                else {
                    aux = aux + (parseFloat(element.preciopormayor)) * element.cantidad;
                }
            });
            setDescuentos(rData)
            setTotal(aux)
            if (venta.length > 0) {
                setAuxVenta(venta)
                setAuxTotal(aux)
            }
        }
        calcTotal()
    }, [venta])

    useEffect(() => {
        if (medioPago === '4') {
            let array = [...venta]
            let cantLineas = array.length + 1;
            let linea = {
                "id": 1,
                "idlinea": cantLineas,
                "codigo": '001',
                "cantidad": 1,
                "name": '',
                "descripcion": 'Cargo por transf.',
                "descripcionext": 'Cargo por pago con transferencia',
                "precio": parseFloat(porcentajeTransf) * total / 100,
                "precioextra": 0,
                "preciocosto": parseFloat(porcentajeTransf) * total / 100,
                "preciopromocion": parseFloat(porcentajeTransf) * total / 100,
                "preciopormayor": parseFloat(porcentajeTransf) * total / 100,
                "nota": '',
                "stock": 0,
                "stockmin": 0,
                "idmarca": 0,
                "idrubro": 0,
                "unidadmedida": 0,
                "marca": 0,
                "rubro": 0,
                "unidad": 0,
                "tipopromo": 0,
                "coeficientepromo": 0,
                "cantidadminima": 0,
                "cantidaddescuento": 0,
                "tipoprod": 0,
                "subproductos": [],
                "imagen": ''
            }
            array.push(linea)
            setVenta(array)
        }
        else {
            //let array = [...venta];
            let rData = [];
            venta.forEach(element => {
                if (element.id !== 1) {
                    rData.push(element)
                }
            });
            setVenta(rData);
        }

    }, [medioPago])

    useEffect(() => {
        const getMedios = async () => {
            const formData = new FormData()
            try {
                const results = await axios({
                    url: Url + 'api/listmediospago.php',
                    method: 'POST',
                    data: formData,
                })
                setMedios(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getMedios()
    }, [])

    useEffect(() => {
        const consultaClientes = async () => {
            const formData = new FormData()
            //formData.append('idusuario', idUsuario)
            formData.append('busqueda', "")
            try {
                const response = await axios({
                    url: Url + 'api/listClientes.php',
                    method: 'POST',
                    data: formData,
                })
                setClientes(response.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        consultaClientes()
    }, [modify])

    useEffect(() => {
        const getEnvases = async () => {
            const formData = new FormData()
            //formData.append('idusuario', idUsuario)
            //formData.append('busqueda', "")
            try {
                const response = await axios({
                    url: Url + 'api/getEnvases.php',
                    method: 'POST',
                    data: formData,
                })
                if (typeof response.data.results !== 'undefined') {
                    setEnvases(response.data.results);
                    setEnvase(response.data.results[0].id)
                }
            } catch (e) {
                console.log(e)
            }
        }
        getEnvases()
    }, [])

    const handleHora = (time) => {
        setCustom(1)
        setHoraCustom(time)

    }

    const facturaAfip = async () => {
        if (total > 0 && medioPago === '5') {
            setProcesando(true)
            const formData = new FormData()
            formData.append('total', total);
            try {
                const response = await axios({
                    url: Url + 'api/factura.php',
                    method: 'POST',
                    data: formData,
                })
                setProcesando(false)
                setDatosFactura(response.data.results.cae)
            } catch (e) {
                console.log(e)
            }
        }
    }

    const finalizarVenta = async (idC) => {

        if (idCliente !== 0 || idC !== 0) {
            let tipoPrecio = 0;
            if (precio) {
                tipoPrecio = 1;
            }
            const rAuxVenta = JSON.stringify(venta)
            const auxEnvases = JSON.stringify(listEnvases)
            const auxDescuentos = JSON.stringify(descuentos)
            let hc = 0;
            if (custom) {
                hc = 1;
            }

            const formData = new FormData()

            formData.append('venta', rAuxVenta);
            formData.append('mediopago', medioPago);
            formData.append('idusuario', idUsuario);
            formData.append('cliente', idCliente);
            formData.append('total', total);
            formData.append('puntoventa', puntoVenta);
            formData.append('tipoprecio', tipoPrecio);
            formData.append('envases', auxEnvases);
            formData.append('efectivo', efectivo);
            formData.append('descuentos', auxDescuentos);
            formData.append('hora', horaCustom);
            formData.append('custom', hc);

            try {
                const response = await axios({
                    url: Url + 'api/finVenta.php',
                    'Content-Type': 'application/json',
                    method: 'POST',
                    data: formData,
                    dataType: 'JSON',
                })
                //console.log(response)
                setIdCliente(0)
                setIdComprobante(response.data.results.idcomprobante);
                setFecha(response.data.results.fecha);

                setHora(response.data.results.hora);
                setNombre(response.data.results.nombre)
                setRazonSocial(response.data.results.razonsocial)
                setCuit(response.data.results.cuit)
                setFechaInicio(response.data.results.fechainicio)
                setAuxVenta(venta)
                setAuxTotal(total)
                setVenta([]);
                setFinVenta(true)

                let aux = modify + 1;
                setModify(aux)
                setDatosFactura('')

            } catch (e) {
                console.log(e)
            }
        }
    }

    const saveCliente = async () => {
        if (idCliente === 0 && searchCliente !== '') {
            const formData = new FormData()
            formData.append('apellido', searchCliente);
            formData.append('nombre', '');
            formData.append('domicilio', searchCliente);
            formData.append('telefono', '');
            formData.append('email', '');
            formData.append('observaciones', '');
            try {
                const response = await axios({
                    url: Url + 'api/clientesAlta.php',
                    method: 'POST',
                    data: formData,
                })
                setIdCliente(response.data.results.idcliente)
                finalizarVenta(response.data.results.idcliente)
            } catch (e) {
                console.log(e)
            }
        }
    }

    const setComanda = async () => {
        const formData = new FormData()
        formData.append('idcomprobante', idComprobante);
        try {
            const response = await axios({
                url: Url + 'api/setComanda.php',
                method: 'POST',
                data: formData,
            })
            console.log("comanda ", response)
        } catch (e) {
            console.log(e)
        }
    }

    return (
        <div className="w-full mx-auto">
            {!finVenta ? (
                <div className='w-10/12 mx-auto'>
                    <div className='w-full mx-auto'>
                        <p className='text-center bg-orange-200 p-4 rounded-lg text-5xl font-light'>Ésta venta $ {total.toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                    </div>

                    <DetallePedido />
                    <div className='bg-gray-50 rounded-lg p-5 w-full'>
                        <div className='w-full'>
                            <h3 className='text-center uppercase text-2xl mb-4'>Cliente</h3>
                            <div className='w-full mt-1 mb-5 bg-gray-50 rounded-lg flex'>
                                <div className="w-3/4 sm:items-start">
                                    <SearchAutoCompCli items={clientes} />
                                </div>
                            </div>
                        </div>
                        <div className='w-full p-3 bg-blue-200 rounded-xl'>
                            {!custom ? (
                                <div className="w-1/4 sm:items-start">
                                    <button type='button'
                                        className='p-2 bg-blue-500 text-white uppercase font-semibold rounded'
                                        onClick={() => setCustom(true)}
                                    >
                                        Establecer horario de entrega
                                    </button>
                                </div>

                            ) : (
                                <div className='w-full'>
                                    <div className='w-full flex'>
                                        <div className='w-1/2'><p className='text-right text-xl mr-2'>Horario específico de entrega</p></div>
                                        <div className='w-1/2'>
                                            <input
                                                className='text-left text-xl'
                                                type='time'
                                                value={horaCustom}
                                                onChange={(e) => handleHora(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <button type='button'
                                        className='p-2 bg-orange-500 text-white uppercase font-semibold rounded'
                                        onClick={() => setCustom(false)}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='w-full'>
                        <div className='bg-gray-50 rounded-lg p-5 sm:w-full'>
                            {typeof medios !== 'undefined' && medios.map((item, index) =>
                                <div key={index} className="radio">
                                    <label>
                                        <input
                                            type="radio"
                                            name="medioPago"
                                            value={item.id}
                                            checked={medioPago === item.id}
                                            onChange={() => setMedioPago(item.id)}
                                            className='mr-5'
                                        />
                                        {item.descripcion}
                                    </label>
                                </div>
                            )}
                        </div>
                    </div>
                    <div>
                        {medioPago === '1' && (
                            <div className='w-full mt-5 mb-10 bg-blue-200 rounded-lg p-5'>
                                <div className="sm:items-start">
                                    <label className="block text-gray-800 text-2xl uppercase font-bold" htmlFor='efectivo'>Efectivo</label>
                                    <input
                                        type='number'
                                        className='p-2 rounded border border-gray-400 w-full'
                                        value={efectivo}
                                        id="efectivo"
                                        onChange={(e) => setEfectivo(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                                <p className='text-4xl text-center font-bold mt-5'>Cambio: $ {efectivo >= total && parseFloat(efectivo - total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                            </div>
                        )}
                        {medioPago === '4' && (
                            <div className='w-full mt-5 mb-10 bg-blue-200 rounded-lg p-5'>
                                <div className="sm:items-start">
                                    {parseFloat(porcentajeTransf) !== 0 && (
                                        <div>
                                            <p className='text-red-600 uppercase'>El monto total tiene un costo adicional del {parseFloat(porcentajeTransf)}%</p>
                                            <p className='text-gray-600 uppercase'>El recargo es de $ {(parseFloat(porcentajeTransf) * total / 100).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                            <p className='text-gray-600 text-3xl uppercase'>Total $ {(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                            <p className='text-red-600 uppercase'>Una vez realizada la transferencia, es necesario adjuntar el comprobante</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        {medioPago === '5' && (
                            <div className='w-full mt-5 mb-10 bg-gray-50 rounded-lg p-5'>
                                <div className="sm:items-start">
                                    {datosFactura !== '' ? (
                                        <>
                                            <p className='bg-green-300 text-green-800 border border-green-800 rounded-xl p-4 w-full'>Se ha generado la factura con CAE {datosFactura}</p>
                                        </>
                                    ) : (
                                        !procesando ? (
                                            <button type='button'
                                                className='w-full p-3 bg-blue-500 text-white uppercase font-semibold rounded'
                                                onClick={() => facturaAfip()}
                                            >
                                                Generar Factura Electrónica
                                            </button>

                                        ) : (
                                            <p className='bg-gray-300 text-gray-800 border border-gray-800 rounded-xl p-4 w-full'>Aguarde mientras se genera la factura, por favor</p>
                                        )

                                    )}
                                </div>
                                <p className='text-xl font-bold mt-5'>Cambio: ${efectivo > total && parseFloat(efectivo - total)}</p>
                            </div>
                        )}
                    </div>
                    <div className='w-1/3 mx-auto'>
                        <button type='button'
                            className={`w-full p-3 text-white uppercase font-semibold rounded ${(idCliente !== 0 || searchCliente !== '') ? 'bg-green-500' : 'bg-green-100 '}`}
                            onClick={idCliente !== 0 ? () => finalizarVenta(0) : () => saveCliente()}
                        >
                            Finalizar venta
                        </button>
                    </div>
                </div>

            ) : (
                <div className='w-10/12 mx-auto'>
                    <div className='print:px-4 print:text-xs print:h-svh' ref={componentRef}>
                        <div className='w-full mx-auto'>
                            <p className='text-center text-2xl font-bold print:text-lg'>{nombre}</p>
                            <p className='text-left print:pl-2 rounded-lg text-xl print:text-xs'>{`Razón Social: ${razonSocial}`}</p>

                            <p className='text-left print:pl-2 rounded-lg text-xl print:text-xs'>{`Inicio de Act.: ${fechaInicio}`}</p>
                            <div className='w-full mt-3 mb-7'>
                                <div className='w-full print:pl-2'>
                                    <p className='text-left'>Fecha {fecha}</p>
                                </div>
                                <div className='w-full print:pl-2'>
                                    <p className='text-left'>Hora {hora}</p>
                                </div>
                            </div>
                            <div className='w-full'>
                                <p className='text-left'>Cliente: {searchCliente}</p>
                                {horaCustom !== '00:00' && (
                                    <p className='text-left'>Hora de entrega: {horaCustom}</p>
                                )}
                            </div>
                            {medioPago === '1' && (
                                <div className='w-full mt-1 mb-1'>
                                    <p className='text-left'>Efectivo: $ {parseFloat(efectivo).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                    <p className='text-left'>Cambio: $ {(parseFloat(efectivo) - parseFloat(auxTotal)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                </div>
                            )}
                        </div>
                        <DetallePedido />

                        {typeof descuentos !== 'undefined' && descuentos.length > 0 && (
                            <div className='w-full print:pl-2'>
                                <p className='text-left font-bold uppercase text-3xl print:text-sm'>Descuentos</p>
                            </div>
                        )}
                        {typeof descuentos !== 'undefined' && descuentos.map((item, index) => (
                            <div key={index} className='w-full'>
                                <div className='w-full print:pl-2 print:pr-10'>
                                    <p className='text-left print:text-xs'>{`${item.descripcion}`}</p>
                                </div>
                                <div className='w-full print:pr-10'>
                                    <p className='text-right print:text-xs'>$ {parseFloat(item.monto).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className="w-full rounded-lg px-3 flex justify-center">
                        <button
                            className='w-full'
                            type='button'
                            onClick={() => setComanda()}
                        >
                            <ReactToPrint
                                trigger={() =>
                                    <p
                                        className="w-1/3 sm:w-1/4 flex shadow-md p-3 ml-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                                        onClick={() => setComanda()}
                                    >
                                        <FaPrint className='mx-auto mt-1' />
                                        <span className='mx-auto text-center'>
                                            Imprimir Comprobante
                                        </span>
                                    </p>}
                                content={() => componentRef.current}
                            />
                        </button>
                        <button
                            type="button"
                            className="w-1/4 sm:w-1/6 shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                            onClick={() => setViewOpen(false)}
                        >
                            Salir
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default FinalizarVenta